/* eslint-disable react/jsx-indent */
import React, { useContext } from 'react'

import { Grid, makeStyles, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import PropTypes from 'prop-types'

import FilterButtons from 'components/FilterButtons'
import SearchBox from 'components/SearchBox/SearchBox'
import { adminFilterDictionary, storeFilterDictionary } from 'constants/productsConstants'
import { SUPER_ADMIN, CUSTOMER_SUPPORT } from 'constants/rolesConst'
import useAuthContext from 'contextApi/AuthContext'

const useStyles = makeStyles(() => ({
  container: {
    marginBottom: 30,
  },
  listActions: {
    width: 151,
  },
  divActionsAndFilters: {
    display: 'flex',
    gap: '15px',
  },
  divStates: {
    display: 'flex',
    columnGap: '10px',
  },
}))

const FiltersBox = ({ handleSearch, handleFilterClick, filters, activeFilter }) => {
  const classes = useStyles()
  const {
    userLoggedin: { role },
  } = useContext(useAuthContext)
  const isAdmin = [SUPER_ADMIN, CUSTOMER_SUPPORT].includes(role)
  const filterDictionary = isAdmin ? adminFilterDictionary : storeFilterDictionary
  const { all, visibles, outOfStock, inactive } = filters
  const adminFilters = {
    new: null,
    edited: null,
    all: null,
  }
  const storeFilters = { all, visibles, outOfStock, inactive }
  const filterMapping = isAdmin ? adminFilters : storeFilters
  const showStatusChips = () => {
    return Object.entries(filterMapping).map(([key, value]) => {
      return (
        <Grid item key={key}>
          <FilterButtons
            label={`${!isAdmin ? value : ''} ${filterDictionary[key].name}`}
            onClick={() => handleFilterClick(filterDictionary[key].value)}
            active={activeFilter === filterDictionary[key].value}
          />
        </Grid>
      )
    })
  }

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="flex-end"
      className={classes.container}
    >
      <Grid item>
        <Typography variant="subtitle1">Filtrar por:</Typography>
        <Grid container spacing={1}>
          {Object.keys(filterMapping).length > 0 &&
          Object.values(filterMapping).some((value) => value !== undefined)
            ? showStatusChips()
            : Array.from({ length: 4 }, (_, i) => i).map((_, index) => (
                <Grid item key={`skeleton-${index.toString()}`}>
                  <Skeleton variant="rect" className={classes.skeleton} width={100} height={40} />
                </Grid>
              ))}
        </Grid>
      </Grid>

      <Grid item>
        <SearchBox onSubmit={handleSearch} />
      </Grid>
    </Grid>
  )
}

FiltersBox.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  handleFilterClick: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    all: PropTypes.number,
    visibles: PropTypes.number,
    outOfStock: PropTypes.number,
    inactive: PropTypes.number,
  }).isRequired,
  activeFilter: PropTypes.string,
}

FiltersBox.defaultProps = {
  activeFilter: '',
}

export default FiltersBox
